import { render, staticRenderFns } from "./Order_mobile.vue?vue&type=template&id=aed77f76&scoped=true&"
import script from "./Order_mobile.vue?vue&type=script&lang=js&"
export * from "./Order_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Order_mobile.vue?vue&type=style&index=0&id=aed77f76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed77f76",
  null
  
)

export default component.exports